/**
 * Paths for the interest-accrual screens, kept apart from `routes.ts` so a
 * screen can link to a run without importing the route records (and, through
 * them, the lazy components).
 */

export const TREASURY_ACCRUAL_RUNS_PATH = '/treasury/accrual-runs'

export function accrualRunPath(id: number): string {
  return `${TREASURY_ACCRUAL_RUNS_PATH}/${id}`
}
